'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var green = {};

exports.__exports = green;
